module.exports = __webpack_public_path__ + "static/media/polygonia.55b3d101.webm";